// noinspection JSUnusedGlobalSymbols

const HiveInterface = window.Hive || {};
HiveInterface.eventInterface.onGlobalReady(
  () => Array.from(document.querySelectorAll('form.validate,form.form-validate'))
    .forEach(formElement => {
      const Handler = HiveInterface.getFormHandler(HiveInterface, formElement);
      Handler.prepareSubmit();
    }))
